// @ts-nocheck
import parseQueryString from "@insite/client-framework/Common/Utilities/parseQueryString";
import { PageErrorWrapper } from "@insite/content-library/Components/PageErrorWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import setBreadcrumbs from "@insite/client-framework/Store/Components/Breadcrumbs/Handlers/SetBreadcrumbs";
import { getOrderState, OrderStateContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import { getCurrentPage, getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getHomePageUrl, getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import displayOrder from "@insite/client-framework/Store/Pages/OrderDetails/Handlers/DisplayOrder";
import setReturnNotes from "@insite/client-framework/Store/Pages/RequestRma/Handlers/SetReturnNotes";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import { generateLinksFrom } from "@insite/content-library/Components/PageBreadcrumbs";
import Page from "@insite/mobius/Page";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { useEffect } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => {
    const location = getLocation(state);
    const homePageUrl = getHomePageUrl(state);
    let orderNumber;
    if (location && location.search) {
        const parsedQuery = parseQueryString<{ orderNumber: string }>(location.search);
        orderNumber = parsedQuery.orderNumber;
    }

    return {
        orderNumber,
        homePageUrl,
        orderState: getOrderState(state, orderNumber),
        links: state.links,
        nodeId: getCurrentPage(state).nodeId,
        orderDetailsLink: getPageLinkByPageType(state, "OrderDetailsPage"),
        breadcrumbLinks: state.components.breadcrumbs.links,
    };
};

const mapDispatchToProps = {
    setReturnNotes,
    displayOrder,
    setBreadcrumbs,
};

type Props = PageProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface OrderComplaintPageStyles {
    loadFailedWrapper?: InjectableCss;
    loadFailedText?: TypographyPresentationProps;
}

export const orderComplaintPageStyles: OrderComplaintPageStyles = {
    loadFailedWrapper: {
        css: css`
            display: flex;
            height: 200px;
            justify-content: center;
            align-items: center;
            background-color: ${getColor("common.accent")};
        `,
    },
    loadFailedText: { weight: "bold" },
};

const styles = orderComplaintPageStyles;

const OrderComplaintPage = ({
    id,
    orderNumber,
    orderState,
    links,
    nodeId,
    orderDetailsLink,
    breadcrumbLinks,
    homePageUrl,
    setReturnNotes,
    displayOrder,
    setBreadcrumbs,
}: Props) => {
    useEffect(() => {
        setReturnNotes({ returnNotes: "" });
        if (orderNumber) {
            displayOrder({ orderNumber });
        }

        return () => {
            setBreadcrumbs({ links: undefined });
        };
    }, []);

    useEffect(() => {
        if (!links.areLinksLoading && !breadcrumbLinks && orderNumber) {
            const breadcrumbs = generateLinksFrom(links, nodeId, homePageUrl);

            breadcrumbs.forEach(link => {
                if (link.children === orderDetailsLink?.title) {
                    link.href += `?orderNumber=${orderNumber}`;
                }
            });

            setBreadcrumbs({ links: breadcrumbs });
        }
    }, [breadcrumbLinks, links, orderNumber, nodeId, homePageUrl, orderDetailsLink]);

    return (
        <Page>
            <PageErrorWrapper
                value={orderState}
                badRequestMessage={siteMessage("OrderComplaint_BadRequest")}
                notAuthorizedMessage={siteMessage("OrderComplaint_NotAuthorized")}
                notFoundMessage={siteMessage("OrderComplaint_NotFound")}
                extendedStyles={styles}
            >
                <OrderStateContext.Provider value={orderState}>
                    <Zone contentId={id} zoneName="Content" />
                </OrderStateContext.Provider>
            </PageErrorWrapper>
        </Page>
    );
};

const pageModule: PageModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(OrderComplaintPage),
    definition: {
        hasEditableUrlSegment: true,
        hasEditableTitle: true,
        pageType: "System",
    },
};

export default pageModule;

/**
 * @deprecated Use string literal "RequestRmaPage" instead of this constant.
 */
export const OrderComplaintPageContext = "OrderComplaintPage";
